/**
 * Fixed table header if columns overflows
 * @module fixedTableHeader
 */
import $ from 'jquery';
import Keyboard from './keyboard';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';
export const PLUGIN_NAME = 'fixedTableHeader';
export const DEFAULTS = {
};
export const BASE_CLASS = 'table'
export const MODIFIERS = {
  fixed: 'fixed-header'
};
/**
 * Get container width unaffected by table.
 * @param  {jQuery} $el - table
 */
const getContainerWidth = ($el) => {
  $el.css({display: 'none'});
  const containerWidth = $el.parent().width();
  $el.css({display: ''});
  return containerWidth;
}
/**
 * Check if table body exist. If not, add it to dom.
 * @param  {jQuery} $el - element
 */
const checkTBody = ($el) => {
  const $tr = $el.find('tr');
  if(!$tr.parent('tbody').length) {
    $tr.wrapAll('<tbody></tbody>');
  }
}
/**
 * Add modifier class
 * @param  {jQuery} $el - element
 * @param  {jQuery} modifier - modifier
 */
const mod = ($el, modifier) => {
  $el.addClass(`${BASE_CLASS}--${modifier}`);
}
/**
 * Apply padding to table in place of table head
 * @param  {jQuery} $el - table
 */
const applyHeadPadding = ($el) => {
  const $th = $el.find('th');
  $el.css({paddingLeft: `${$th.outerWidth(true)}px`});
}
/**
 * Apply th height just in case a row is in multiline
 * @param  {jQuery} $el - table
 */
const applyTHHeight = ($el) => {
  const $tr = $el.find('tr');
  $tr.each(function () {
    const $thisTr = $(this);
    const $td = $thisTr.find('td');
    let tdMaxHeight = 0;
    $td.each(function(){
      const tdHeight = $td.outerHeight();
      if(tdHeight > tdMaxHeight) {
        tdMaxHeight = tdHeight;
      }
    })
    $thisTr.find('th').css({height: tdMaxHeight});
  });

}
/**
 * Fixed head
 * @param  {jQuery} $el - table
 */
const fixedHead = ($el) => {
  const $th = $el.find('th');
  $th.wrapAll(`<thead class="${BASE_CLASS}__head-wrap"></thead>`);
  const $tHead = $el.find(`.${BASE_CLASS}__head-wrap`);
  $th.wrap('<tr class="table__row"></tr>');
  $el.prepend($tHead);
}
/**
 * Check and apply dom manipulation for fixed header
 * @param  {jQuery} $el - table
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const applyFixedHeader = ($el, options = {}) => {
  const tableWidth = $el.width();
  const containerWidth = getContainerWidth($el);
  if(tableWidth > containerWidth) {
    checkTBody($el);
    applyTHHeight($el);
    applyHeadPadding($el);
    fixedHead($el);
    mod($el, MODIFIERS.fixed);
  }
}
/**
 * Initializes Header.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function fixedTableHeader(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  applyFixedHeader($el, opts);
  return {
    check: () => applyFixedHeader($el, opts),
};
}
registerJQueryPlugin(PLUGIN_NAME, fixedTableHeader);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/fixed-table-header.js